import { render, staticRenderFns } from "./CatContent.vue?vue&type=template&id=604bedd6&"
import script from "./CatContent.vue?vue&type=script&lang=js&"
export * from "./CatContent.vue?vue&type=script&lang=js&"
import style0 from "./CatContent.vue?vue&type=style&index=0&id=604bedd6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports